import {Grid} from '@mui/material';
import {ReactNode} from 'react';

export default function TwoDeckContainer(props: {left_side_child?: ReactNode; right_side_child?: ReactNode}) {
	const {left_side_child, right_side_child} = props;

	return (
		<Grid container id="deck-container" width="100%" justifyContent={{xs: 'center', lg: 'space-between'}} gap={2}>
			{left_side_child && (
				<Grid item id="left-deck" md={8} lg={5.8} flexGrow={1} maxWidth="95vw" display="flex" flexDirection="column">
					{left_side_child}
				</Grid>
			)}

			{right_side_child && (
				<Grid item id="right-deck" md={8} lg={5.8} flexGrow={1} maxWidth="95vw" display="flex" flexDirection="column">
					{right_side_child}
				</Grid>
			)}
		</Grid>
	);
}
